package com.eladfinish.bible.contest.screens.search.analytics

import com.russhwolf.settings.Settings
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

interface AnonymousInstallationIdProvider {

    fun getAnonymousInstallationId(): String
}

class SettingsAnonymousInstallationIdProvider(
    private val settings: Settings,
) : AnonymousInstallationIdProvider {

    override fun getAnonymousInstallationId(): String {
        val existingId = settings.getStringOrNull(
            key = KEY_ANONYMOUS_INSTALLATION_ID,
        )

        if (existingId != null) {
            return existingId
        }

        return createAndPersistId()
    }

    @OptIn(ExperimentalUuidApi::class)
    private fun createAndPersistId(): String {
        val newId = Uuid.random().toString()

        settings.putString(
            key = KEY_ANONYMOUS_INSTALLATION_ID,
            value = newId,
        )

        return newId
    }

    private companion object {
        const val KEY_ANONYMOUS_INSTALLATION_ID =
            "key_anonymous_installation_id"
    }
}
